import { atom } from "recoil"

import type { Jobseeker } from "../interfaces/IJobseeker"

export const jobseekerState = atom<Jobseeker[]>({
  key: "jobseeker",
  default: [],
})
